import React, { Component } from 'react';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';

class IeWarning extends Component {
  render() {
    let isIE = undefined;
    if (typeof document !== 'undefined') {
      // Internet Explorer 6-11
      isIE = /*@cc_on!@*/ false || !!document.documentMode;
    }
    const { t } = this.props;

    return (
      <div>
        {isIE && (
          <div className="card-body">
            <div
              className={`alert alert-info` + ' container col-6 flex-column'}
            >
              {this.props.i18n.t('iemsg')}
            </div>
          </div>
        )}
      </div>
    );
  }
}

IeWarning.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate('IeWarning')(IeWarning);



// WEBPACK FOOTER //
// ./src/components/IeWarning/index.js